export const keyFeaturesCardData = [
  {
    cardNumber: "1",
    heading: "Real Time Progression Tracking",
    description:
      "Real Time Progress Dashboard provides immediate insights into test execution progress and results, allowing teams to monitor and analyze testing activities more efficiently and effectively.",
  },
  {
    cardNumber: "2",
    heading: "Report Customization",
    description:
      "Users can customize screenshot captured during test execution, visually documenting the application's state at specific testing points, thus enhancing reporting standards.",
  },
  {
    cardNumber: "3",
    heading: "Email Generation",
    description:
      "Automatic report generation after each test case execution streamlines project communication, fostering collaboration and enabling swift issue resolution.",
  },
  {
    cardNumber: "4",
    heading: "Automation Support",
    description:
      "GemJar supports headless mode for executing test cases without a graphical user interface, along with incognito mode to maintain a clean state for each test, preventing data interference. ",
  },
  {
    cardNumber: "5",
    heading: "Parallel Execution",
    description:
      "GemJar offers support for executing multiple test cases in parallel or sequential mode, enhancing efficiency and ensuring specific order requirements.",
  },
  {
    cardNumber: "6",
    heading: "Cross-Browser",
    description:
      "GemJar ensures cross-browser testing, enabling the validation of application functionality across different web browsers, thereby ensuring a consistent user experience.",
  },
  {
    cardNumber: "7",
    heading: "Tool Integration",
    description:
      "GemJar seamlessly integrates with test and issue management tools such as JIRA and Microsoft Azure, autonomously creating workflow requests for each test execution, streamlining the bug tracking and issue resolution process.",
  },
  {
    cardNumber: "8",
    heading: "Framework Integration",
    description:
      "GemJar supports seamless integration with other test automation frameworks, including TestNG, Junit, Serenity, and Cucumber, enhancing automation capabilities through a cohesive utilization of these frameworks.",
  },
];

export const howIsGemJarEfficientData = [
  {
    heading: "Effortless Execution",
    description:
      "Offer codeless automation experience, enabling users to effortlessly create and execute tests without the need for manual coding.",
  },
  {
    heading: "Comprehensive Framework",
    description:
      "Comprehensive testing framework that covers planning, execution, and reporting, streamlining the entire web automation process.",
  },
  {
    heading: "Dynamic Reporting",
    description:
      "Real Time insights of test case execution on our in-house dashboard with auto-generated detailed reports.",
  },
  {
    heading: "Smooth Onboarding",
    description:
      "Balancing simplicity for beginners and advanced features for experts, our web automation interface ensures a seamless, efficient experience.",
  },
];
